import React, { useContext, useEffect } from "react";
import { Segment, Tab } from "semantic-ui-react";
import EditBrokerForm from "./EditBrokerForm";
import { observer } from "mobx-react-lite";
import DashboardUsersBroker from "../usersBroker/DashboardUsersBroker";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import BreadcrumbContainer from "../../../../app/common/breadcrumb/BreadcrumbContainer";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { useParams } from "react-router-dom";
import { sectionBroker } from "../../../../app/util/breadcrumbOptions";
import PackageBroker from "./PackageBroker";

const DashboardNewBroker: React.FC = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { broker, loadBroker, getBrokerById, reset,getPackagesBrokers } = rootStore.brokerStore;

  const { id } = useParams<{ id: string }>();

  let panes;

  useEffect(() => {
    reset();
    if (id !== "null") {
      getBrokerById(id);
      getPackagesBrokers(id);
    }
  }, [reset, getBrokerById,id,getPackagesBrokers]);

  if ((id || broker.id) !== "null") {
    panes = [
      {
        menuItem: "Datos básicos",
        render: () => (
          <Tab.Pane>
            <EditBrokerForm id={id} />
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Usuarios",
        render: () => (
          <Tab.Pane>
            <DashboardUsersBroker id={id}/>
          </Tab.Pane>
        ),
      },
      {
        menuItem: "Paquetes",
        render: () => (
          <Tab.Pane>
            <PackageBroker id={id}/>
          </Tab.Pane>
        ),
      },
    ];
  } else {
    panes = [
      {
        menuItem: "Datos básicos",
        render: () => (
          <Tab.Pane>
            <EditBrokerForm id={id} />
          </Tab.Pane>
        ),
      },
    ];
  }

  if (id === "null")
    document.title = "Nuevo agente";
  else document.title = "Editando agente";

  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title={
          id === "null"
            ? "Nuevo agente"
            : "Editando agente"
        }
        sections={sectionBroker}
      />
      <Segment >
        <div className="configurationContent">
          {id !== "null" && !loadBroker ? (
            <LoadingComponent content="Cargando informacíon" />
          ) : (
            <Tab panes={panes} />
          )}
        </div>
      </Segment>
    </div>
  );
};

export default observer(DashboardNewBroker);
